import { render } from "./politic.vue?vue&type=template&id=733018b3"
import script from "./politic.vue?vue&type=script&lang=js"
export * from "./politic.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Прогерство\\vue\\new_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__